var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('main-header'),_c('parcel-detail-content',{attrs:{"parcel-key":_vm.parcelID},on:{"detailClosed":_vm.onDetailClosed}})],1),_c('message-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }